module.exports = __webpack_public_path__ + "static/media/twitter.41f6a267.jpg";